import { Label } from "layout/typography/Label";
import { ToggleButton } from "primereact/togglebutton";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IReceiptContent } from "types/Customize";
import { OrderType } from "types/Order/OrderType";

import { StyledCard } from "../styled";

interface IReceiptContentFields {
  "GFE-version2Receipt"?: boolean;
  "Bundled-version2Receipt"?: boolean;
  "Bariatrics-version2Receipt"?: boolean;
  "ED-version2Receipt"?: boolean;
  "PatientResponsibility-version2Receipt"?: boolean;
}

export function ReceiptForm({
  customFields,
  orderType,
}: {
  customFields?: IReceiptContent;
  orderType: OrderType;
}) {
  const { control, setValue } = useFormContext<IReceiptContentFields>();

  const initializeFields = () => {
    setValue(
      `${orderType}-version2Receipt`,
      customFields?.version2Receipt || false
    );
  };

  useEffect(() => {
    initializeFields();
  }, [customFields, orderType]);

  return (
    <StyledCard
      data-test-id="customize-pdf-content"
      title="Order Receipt Version"
    >
      <div className="flex flex-column gap-2">
        <Label
          htmlFor={`${orderType}-version2Receipt`}
          data-test-id={`${orderType}-version2Receipt`}
        >
          Version 2 Receipt
        </Label>

        <Controller
          data-test-id={`${orderType}-version2Receipt`}
          name={`${orderType}-version2Receipt`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <ToggleButton
              id={`${orderType}-version2Receipt`}
              checked={value}
              onChange={onChange}
              className="w-8rem"
            />
          )}
        />
      </div>
    </StyledCard>
  );
}
